import type { PositionTick } from "./live";

/**
 * M31 — the MT4-style floating total of the OPEN book.
 *
 * Sums the QUERY-known positions, preferring a fresh tick per id — never the tick store
 * alone: the store can lag the structural refetch by a TTL, and summing it directly would
 * keep a closed trade's P/L in the total (and a stale tick is a frozen number, not a
 * price). Null for an empty book — "no positions" is not a claim that P/L is zero — and a
 * position with no known profit anywhere is skipped rather than counted as zero.
 */
export function floatingTotal(
  positions: readonly { id: string; profit?: number | null }[],
  ticks: ReadonlyMap<string, PositionTick>,
): number | null {
  if (positions.length === 0) return null;
  let total = 0;
  let known = false;
  for (const position of positions) {
    const tick = ticks.get(position.id);
    const profit = tick && !tick.stale && typeof tick.profit === "number" ? tick.profit : position.profit;
    if (typeof profit !== "number") continue;
    known = true;
    total += profit;
  }
  return known ? Math.round(total * 100) / 100 : null;
}
